import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { finalize, firstValueFrom, Observable, of, switchMap, throwError } from 'rxjs';
import { SpinnerOverlayComponent } from 'src/app/components/spinner-overlay/spinner-overlay.component';
import { DialogCreaCfgImpattoComponent } from 'src/app/page/configurazioni/cfg-impatti/dialog/dialog-crea-cfg-impatto/dialog-crea-cfg-impatto.component';
import {
  DoppiaMaterialitaService,
  ElementiCheckati,
  ImpattoIro,
  Opportunita,
  Rischio,
} from 'src/app/services/doppia-materialita/doppia-materialita.service';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { DialogCreaIroComponent } from '../dialog-crea-iro/dialog-crea-iro.component';
import { DialogVisualValidazioniIroComponent } from '../dialog-visual-validazioni-iro/dialog-visual-validazioni-iro.component';
import { TooltipVariabiliIroComponent } from '../dialog-crea-doppia-materialita/tooltip-variabili-iro/tooltip-variabili-iro.component';

@Component({
  selector: 'app-dialog-selezione-iro-doppia-mat',
  standalone: false,

  templateUrl: './dialog-selezione-iro-doppia-mat.component.html',
  styleUrl: './dialog-selezione-iro-doppia-mat.component.scss',
})
export class DialogSelezioneIroDoppiaMatComponent implements OnInit, AfterViewInit {
  @ViewChild(SpinnerOverlayComponent) spinnerOver!: SpinnerOverlayComponent;
  @ViewChild(TooltipVariabiliIroComponent) cmpTooltipVatiableIro!: TooltipVariabiliIroComponent;

  private _titolo = '';

  get titolo() {
    return this._titolo;
  }

  private _canEdit = true;

  get canEdit() {
    return this._canEdit;
  }

  private _loading = false;

  get loading() {
    return this._loading;
  }

  private _modificato = false;

  get modificato() {
    return this._modificato;
  }

  private _iroArray: (ImpattoIro | Rischio | Opportunita)[] = [];

  get iroArray() {
    return this._iroArray;
  }

  constructor(
    public dialogRef: MatDialogRef<DialogSelezioneIroDoppiaMatComponent>,
    private readonly doppiaMaterialitaService: DoppiaMaterialitaService,
    private readonly utilityService: UtilityService,
    private readonly dialog: MatDialog,
    private readonly cdRef: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      canEdit: boolean;
      tipoIro: 'impatto' | 'rischio' | 'opportunita';
      idDoppiaMaterialita: string;
      idAmbito: string;
      idTematica: string;
      idTema?: string;
      titoloTematica?: string;
      titoliEsrs?: { titolo: string; etichetta: string }[];
    },
  ) {
    this._canEdit = !!data.canEdit;

    if (this.data.tipoIro === 'impatto') {
      this._titolo = 'Impatti';
    } else if (this.data.tipoIro === 'opportunita') {
      this._titolo = 'Opportunità';
    } else if (this.data.tipoIro === 'rischio') {
      this._titolo = 'Rischi';
    }
  }

  ngOnInit() {}

  ngAfterViewInit() {
    this._caricaIro();
  }

  public async annulla() {
    if (!this.modificato) {
      // Niente di modificato, non c'è niente da salvare
      this.dialogRef.close();
      return;
    }

    const dialog = await this.utilityService.openDialog({
      titolo: 'Attenzione',
      descrizione: 'I dati non salvati andranno persi. Continuare?',
      bottoni: [
        {
          nome_btn: 'No',
          id_btn: 'N',
        },
        {
          nome_btn: 'Si',
          id_btn: 'S',
        },
      ],
    });

    const valDialog = await firstValueFrom(dialog.beforeClosed());

    if (valDialog === 'S') {
      this.dialogRef.close();
    }
  }

  public salva() {
    if (this.canEdit) {
      this.spinnerOver.show();
      this._eseguiSalvataggio()
        .pipe(finalize(() => this.spinnerOver.hide()))
        .subscribe({
          next: (esito) => {
            this.dialogRef.close();
          },
          error: (err) => {
            // Errore salvataggio - nessuna risposta
            console.error('ERRORE SALVATAGGIO : ', err);
            this.utilityService.openDialog({
              titolo: 'Attenzione',
              descrizione:
                'Impossibile salvare i dati: ' +
                (err?.message || err?.msg || err || 'Errore sconosciuto'),
              bottoni: [
                {
                  nome_btn: 'OK',
                },
              ],
            });
          },
        });
    } else {
      this.dialogRef.close();
    }
  }

  selezionaCheck(iro: ImpattoIro | Rischio | Opportunita, selected: boolean) {
    if (!this.canEdit || iro.validato) {
      // Elemento non modificabile
      return;
    }

    if (
      this.data.tipoIro === 'impatto' &&
      selected &&
      (!(iro as ImpattoIro).impattoPositivoNegativo?.length ||
        !(iro as ImpattoIro).impattoPotenzialeEffettivo?.length)
    ) {
      iro.selected = true;

      this._dialogCreaCfgImpatto(iro as ImpattoIro).subscribe((result: any) => {
        if (!result) {
          iro.selected = false;
          selected = false;
        }
        this._caricaIro();
        this._modificato = true;
      });
    } else {
      iro.selected = selected;
      this._modificato = true;
    }
  }

  public creaElemento() {
    if (this.data.tipoIro === 'impatto') {
      this._dialogCreaCfgImpatto().subscribe((esito) => {
        if (esito) {
          this._caricaIro();
        }
      });
    } else if (this.data.tipoIro === 'opportunita') {
      this._dialogCreaIro().subscribe((esito) => {
        if (esito) {
          this._caricaIro();
        }
      });
    } else if (this.data.tipoIro === 'rischio') {
      this._dialogCreaIro().subscribe((esito) => {
        if (esito) {
          this._caricaIro();
        }
      });
    }
  }

  public editElemento(elemento: ImpattoIro | Rischio | Opportunita) {
    if (this.data.tipoIro === 'impatto') {
      this._dialogCreaCfgImpatto(elemento as ImpattoIro).subscribe((esito) => {
        if (esito) {
          this._caricaIro();
        }
      });
    } else if (this.data.tipoIro === 'opportunita') {
      this._dialogCreaIro(elemento as Opportunita).subscribe((esito) => {
        if (esito) {
          this._caricaIro();
        }
      });
    } else if (this.data.tipoIro === 'rischio') {
      this._dialogCreaIro(elemento as Rischio).subscribe((esito) => {
        if (esito) {
          this._caricaIro();
        }
      });
    }
  }

  public mostraValidazioni(elemento: ImpattoIro | Rischio | Opportunita) {
    const dialogCreaImpatto = this.dialog.open(DialogVisualValidazioniIroComponent, {
      data: {
        tipoIro: this.data.tipoIro,
        elemento: elemento,
      },
      panelClass: 'dialog-container',
      disableClose: false,
      width: '75%',
      maxHeight: '95%',
      autoFocus: false,
    });

    return dialogCreaImpatto.afterClosed().pipe(
      switchMap((result) => {
        if (result) {
          return of(true);
        } else {
          return of(false);
        }
      }),
    );
  }

  private _eseguiSalvataggio() {
    const elementiSel: ElementiCheckati[] = [
      {
        idAmbito: this.data.idAmbito,
        idTematica: this.data.idTematica,
        idTema: this.data.idTema,
        idElementi: this.iroArray
          .filter((iro: ImpattoIro | Rischio | Opportunita) => iro.selected)
          .map((iro: ImpattoIro | Rischio | Opportunita) => iro.id),
      },
    ];

    let obs: Observable<any>;

    if (this.data.tipoIro === 'impatto') {
      obs = this.doppiaMaterialitaService.putCheckImpattiEffimeri(
        this.data.idDoppiaMaterialita,
        elementiSel,
      );
    } else if (this.data.tipoIro === 'opportunita') {
      obs = this.doppiaMaterialitaService.putCheckOpportunitaEffimeri(
        this.data.idDoppiaMaterialita,
        elementiSel,
      );
    } else if (this.data.tipoIro === 'rischio') {
      obs = this.doppiaMaterialitaService.putCheckRischiEffimeri(
        this.data.idDoppiaMaterialita,
        elementiSel,
      );
    } else {
      // Non gestito
      console.error('Tipo non gestito : ', this.data.tipoIro);

      return throwError(() => 'tipo non riconosciuto)');
      /* this.utilityService.openDialog({
        titolo: 'Attenzione',
        descrizione: 'Impossibile salvare i dati: tipo non riconosciuto',
        bottoni: [
          {
            nome_btn: 'OK'
          }
        ]
      });
      return; */
    }

    return obs.pipe(
      switchMap((esito) => {
        if (!esito) {
          console.error('NESSUNA RISPOSTA');
          return throwError(() => 'Nessuna risposta');
        }

        return of(esito);
      }),
    );
  }

  private _caricaIro() {
    this.spinnerOver.show();

    this._loading = true;
    this.cdRef.detectChanges();

    let obs: Observable<any>;

    if (this.data.tipoIro === 'impatto') {
      obs = this.doppiaMaterialitaService.getImpatti(
        this.data.idDoppiaMaterialita,
        this.data.idAmbito,
        this.data.idTematica,
        this.data.idTema,
      );
    } else if (this.data.tipoIro === 'opportunita') {
      obs = this.doppiaMaterialitaService.getOpportunita(
        this.data.idDoppiaMaterialita,
        this.data.idAmbito,
        this.data.idTematica,
        this.data.idTema,
      );
    } else if (this.data.tipoIro === 'rischio') {
      obs = this.doppiaMaterialitaService.getRischi(
        this.data.idDoppiaMaterialita,
        this.data.idAmbito,
        this.data.idTematica,
        this.data.idTema,
      );
    } else {
      // Tipo errato o non gestito
      console.error('TIPO IRO NON RICONOSCIUTO : ', this.data.tipoIro);
      this.utilityService.openDialog({
        titolo: 'Attenzione',
        descrizione: 'Impossibile caricare i dati: tipo non riconosciuto',
        bottoni: [
          {
            nome_btn: 'OK',
          },
        ],
      });
      this.dialogRef.close();
      return;
    }

    obs
      .pipe(
        finalize(() => {
          this._loading = false;
          this.cdRef.detectChanges();
        }),
      )
      .subscribe({
        next: (result) => {
          // Riporta i valori di selected che erano presenti in interfaccia
          result.forEach((val: ImpattoIro | Rischio | Opportunita) => {
            const corrispondente = this._iroArray.find((iro) => iro.id === val.id);

            if (corrispondente) {
              val.selected = corrispondente.selected;
            }
          });

          this._iroArray = result || [];

          this.spinnerOver.hide();
        },
        error: (err) => {
          console.error('ERRORE GET IRO : ', err);

          this.spinnerOver.hide();

          this.utilityService.openDialog({
            titolo: 'Attenzione',
            descrizione:
              'Impossibile caricare i dati: ' +
              (err?.message || err?.msg || err || 'Errore sconosciuto'),
            bottoni: [
              {
                nome_btn: 'OK',
              },
            ],
          });
          this.dialogRef.close();
        },
      });
  }

  /**
   * Ritorna l'etichetta + il titolo del tema, sotto tema, etc... a cui l'elemento è collegato
   * @returns
   */
  private _getTitoloEsrs() {
    /*   const etichetta: string[] = ['TEMA', 'SOTTO TEMA', 'SOTTO SOTTO TEMA'] */

    if (this.data.titoliEsrs?.length) {
      const lastIndex = this.data.titoliEsrs.length - 1;

      return this.data.titoliEsrs.at(lastIndex);
    } else {
      return {
        etichetta: 'Tematica - ',
        titolo: this.data.titoloTematica,
      };
    }
  }

  private _dialogCreaCfgImpatto(impatto?: ImpattoIro): Observable<boolean> {
    const dialogCreaImpatto = this.dialog.open(DialogCreaCfgImpattoComponent, {
      data: {
        impatto: impatto,
        idContest: this.data.idDoppiaMaterialita,
        idAmbito: this.data.idAmbito,
        idTematica: this.data.idTematica,
        idTema: this.data.idTema,
        contesto: 'doppiamaterialita',
        titoloESRS: this._getTitoloEsrs(),
      },
      panelClass: 'dialog-container',
      disableClose: false,
      width: '75%',
      maxHeight: '95%',
      autoFocus: false,
    });

    return dialogCreaImpatto.afterClosed().pipe(
      switchMap((result) => {
        if (result) {
          return of(true);
        } else {
          return of(false);
        }
      }),
    );
  }

  private _dialogCreaIro(elemento?: Rischio | Opportunita): Observable<boolean> {
    const dialogCreaImpatto = this.dialog.open(DialogCreaIroComponent, {
      data: {
        tipoIro: this.data.tipoIro,
        elemento: elemento,
        idContest: this.data.idDoppiaMaterialita,
        idAmbito: this.data.idAmbito,
        idTematica: this.data.idTematica,
        idTema: this.data.idTema,
        contesto: 'doppiamaterialita',
        titoloESRS: this._getTitoloEsrs(),
      },
      panelClass: 'dialog-container',
      disableClose: false,
      width: '75%',
      maxHeight: '95%',
      autoFocus: false,
    });

    return dialogCreaImpatto.afterClosed().pipe(
      switchMap((result) => {
        if (result) {
          return of(true);
        } else {
          return of(false);
        }
      }),
    );
  }

  getIndentazioneStyle(): string {
    if (this.data.titoliEsrs?.length) {
      return `${16 + 10 * this.data.titoliEsrs.length}px`;
    } else {
      return '5px';
    }
  }

  haVariabili(iro: any): boolean {
    if (!iro) return false;

    // helper function
    const hasValue = (v: unknown): boolean => {
      if (v === null || v === undefined) return false;
      if (typeof v === 'string') return v.trim().length > 0;
      if (Array.isArray(v)) return v.length > 0;
      if (typeof v === 'object') return Object.keys(v).length > 0;
      return true; // numeri, booleani
    };

    return [
      iro.impattoPotenzialeEffettivo,
      iro.impattoPositivoNegativo,
      iro.impattoDirettoIndiretto,
      iro.fonte,
      iro.catene,
      iro.orizzontiTemporali,
    ].some(hasValue);
  }
}
